<template>
    <main>
        <header>
            <nav class="navbar navbar-dark bg-dark">
                <div class="container" style="max-width: 100%">
                    <router-link class="navbar-brand" to="/dashboard">
                        <img src="../assets/hr-logo-text.png" alt="" height="24">
                    </router-link>
                    <div class="d-flex search-input-container">
                        <input class="form-control me-2 search-input" type="text" placeholder="Search" aria-label="Search" v-model="search" @keyup.enter="searcher">
                        <jl-button class="btn btn-default text-white fw-600" :eventClick="logout">Logout</jl-button>
                    </div>
                </div>
            </nav>
            <nav class="navbar navbar-dark" :class="($route.name.includes('dashboard') ? 'bg-gray' : 'bg-primary')">
                <div class="container" style="max-width: 100%">
                    <ul class="nav nav-pills">
                        <li class="nav-item">
                            <router-link to="/hris" class="nav-link text-white fw-600" :active-class="'active'">HRIS</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link text-white fw-600" to="/vikipedia" :active-class="'active'">Vikipedia</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link  to="/vuniversity" class="nav-link text-white fw-600" :active-class="'active'">V-University</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link text-white fw-600" :active-class="'active'" :class="{'active':$route.name.includes('performance')}" to="/performance">Performance</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link text-white fw-600" :active-class="'active'" :class="{'active':$route.name.includes('appraisal')}" to="/appraisal">Appraisal</router-link>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
        <router-view v-slot="{ Component }" name="main" class="main flex-1">
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </router-view>
        <footer class="px-4 py-2">
            <small class="logo-mis"></small>
        </footer>
    </main>
</template>

<script>
export default {
    data() {
        return {
            search: this.$route.query.s
        }
    },
    methods: {
        async logout(e) {
            this.$cookie.removeCookie(process.env.VUE_APP_COOKIEXID);
            this.$cookie.removeCookie(process.env.VUE_APP_COOKIEAUTH);
            localStorage.removeItem('versatechvex_data');
            this.$router.replace('/');
            await this.$axios.get('/logout');
            this.$jlbutton.unload(e);
        },
        searcher() {
            if(this.search.toString().length < 3) return;

            this.$router.push({path:'/search',query:{s:this.search}});
        }
    }
}
</script>

<style scoped>
main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.search-input {
	border-radius: 3px;
    outline-width: 0;
    padding: 6px 10px;
    background-color: #ffffff2e;
    border: 0;
    color: #fff;
    transition: 0.6s !important;
    cursor: pointer;
    padding-left: 40px;
    font-weight: 600;
    color: #828286;
}

.search-input-container {
	position: relative;
    margin: 0 20px;
}

.search-input-container:before {
	font-family: 'Material Design Icons';
	content: "\F0349";
	font-size: 1.6em;
	font-weight: 500;
	position: absolute;
	color: #ffffff2e;
	padding: 0 10px;	
	display: flex;
	align-items: center;

}

.search-input:hover {
	background-color: #7b7b7bcc;
}

.search-input-container:focus-within:before {
	color: #828286;
}

.search-input:focus, .search-input-container:focus {
	background-color: #fff;
	color: #3c3c3c;
}

.search-input:focus, .search-input:focus-within, .search-input:hover {
    box-shadow: none;
    outline: none;;
}

.bg-dark {
    background: var(--dark-color) !important;
}

.bg-primary {
  background-color: var(--primary-color) !important;
}

.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    background-color: #2453a269 !important;
}

li.nav-item:hover a {
    background-color: #00000024;
}

/* .main {
    flex: 1;
    overflow: auto;
} */
</style>